export class MapSettings {
    settings: any;
    backgroundlayers: any[];
    overlayers: any[]
}